import React, { useEffect, useState } from "react";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import FollowupsListing from "./FollowupsListing";
import { useGetAllFollowupsReportQuery } from "src/services/DashboardService";
import moment from "moment";

const FollowupsListingWrapper = () => {
  const [items, setItems] = useState([]);
  const [noOfDays, setNoOfDays] = useState<number>(0); // Default 0 for today
  const [dateRange, setDateRange] = useState("");

  const { data, isLoading } = useGetAllFollowupsReportQuery({
    noOfDays: noOfDays,
  });

  useEffect(() => {
    setItems(data?.data || []);
    
    // Calculate date range using Moment.js
    const today = moment();
    let rangeText = "";
    
    if (noOfDays === 0) {
      rangeText = today.format("DD MMM YYYY"); // Just today
    } else {
      const endDate = moment().add(noOfDays, 'days');
      rangeText = `${today.format("DD MMM YYYY")} - ${endDate.format("DD MMM YYYY")}`;
    }
    
    setDateRange(rangeText);
  }, [data, noOfDays]);

  const columns: columnTypes[] = [
    { field: "name", headerName: "Name", flex: "flex-[1_1_0%]" },
    { field: "mobile", headerName: "Mobile", flex: "flex-[1_1_0%]" },
    { 
      field: "nextfollowupNoteDate", 
      headerName: "Followup Date", 
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => moment(row.nextfollowupNoteDate).format("DD MMM YYYY")
    },
    { field: "followupNoteStatus", headerName: "Status", flex: "flex-[1_1_0%]" },
  ];

  return (
    <div>
      <FollowupsListing
        columns={columns}
        rows={items}
        isTableLoading={isLoading}
        noOfDays={noOfDays}
        setNoOfDays={setNoOfDays}
        dateRange={dateRange}
      />
    </div>
  );
};

export default FollowupsListingWrapper;